import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { sessionStorageHelper, ShSharesDataService } from '@stylehaven/components';
import { Observable, Subject, throwError } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { shareTokenResolver } from '../../../sharing/helpers/share-token-resolver.helper';
import { TokenRefreshStrategy } from './index';

@Injectable()
export class RefreshShareTokenStrategy implements TokenRefreshStrategy {
    constructor(
        private readonly router: Router,
        private readonly shareService: ShSharesDataService
    ) {}

    refreshToken(
        req: HttpRequest<any>,
        next: HttpHandler,
        callbackSubject: Subject<string | undefined>
    ): Observable<HttpEvent<any>> {
        if (!sessionStorageHelper.has('shareToken')) {
            return throwError('No share token found');
        }
        sessionStorageHelper.remove('shareToken'); // Remove share token so regular token is used for refresh
        const shareId: string | null = sessionStorageHelper.get('shareId');

        if (shareId) {
            return shareTokenResolver(this.router, this.shareService, shareId).pipe(
                tap(shareToken => {
                    sessionStorageHelper.set('shareToken', shareToken);
                }),
                tap(shareToken => callbackSubject.next(shareToken)),
                take(1),
                switchMap(() => next.handle(req))
            );
        }

        sessionStorageHelper.remove('shareId');
        return throwError('Failed to refresh share token');
    }
}
